// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "InsightPage-module--arrow-up-and-down--cf8e0";
export var body = "InsightPage-module--body--241fe";
export var columnTitle = "InsightPage-module--columnTitle--1371b";
export var contentContainer = "InsightPage-module--contentContainer--832e1";
export var insightContainer = "InsightPage-module--insightContainer--14c4b";
export var newsletterContainer = "InsightPage-module--newsletterContainer--c45d6";
export var shareAndNewsletterContainer = "InsightPage-module--shareAndNewsletterContainer--2fe46";
export var shareContainer = "InsightPage-module--shareContainer--54700";